<template>
  <el-container>
    <el-header>
      <navmenu/>
    </el-header>
    <el-main>
      <div class="block">
        <el-carousel trigger="click" height="460px" indicator-position="none" arrow="never">
          <el-carousel-item v-for="item in imgList" :key="item.name">
            <div class="pic_item">
              <img :src="item.src" style="height:100%;width:100%;" alt="图片丢失了" />
              <h3>{{item.title}}</h3>
              <p>{{item.detail}}</p>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="solution">
        <div class="breadCrumb">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/newsCenter' }">新闻中心</el-breadcrumb-item>
            <el-breadcrumb-item>公司新闻</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="content">
          <div class="title">
            <p>活动丨功存智能携手老麦咖啡亮相2020敏捷之旅上海站</p>
            <span>2020.12.13</span>
          </div>
          <div class="detail">
            <p>2020是极其特殊的一年，深刻诠释了VUCA年代的意义，这也促使我们更加深入的思考，作为个体、团队、组织、如何面对世界的不确定性，如何更好的应对世界的复杂多变。</p>
            <div class="picImg_Content">
              <div class="picImg"><img src="../../../public/newsImg/activity1.jpg" alt=""></div> 
            </div>
            <p>12月13日，功存智能作为活动铂金赞助商携手老麦咖啡首次亮相2020敏捷之旅上海站，功存咨询总监徐峰先生围绕议题《借力打力不费力——某金融企业的敏捷转型》向大家分享功存团队针对金融行业的转型实战案例与经验，与此同时功存敏捷教练叶青老师为来宾分享了《游戏行业敏捷转型启示录》，深度解析游戏行业敏捷转型的痛点与解决之道。</p>
            <div class="picImg_Content">
              <div class="picImg"><img src="../../../public/newsImg/activity2.jpg" alt=""></div>
            </div>
            <p style="padding-top:20px">最后功存智能感谢敏捷之旅上海站的邀请，能与行业内知名企业、专家、伙伴共同沟通与交流，分享最新的行业动态和技术成果，未来功存智能也将继续努力前行，融入新发展格局，成为企业敏捷转型的推动者。</p>
            
          </div>
        </div>
        <div class="footNav">
          <ul>
            <li><a href="#/newsCenter/goodNews">上一篇: 喜讯 | 中标喜讯</a></li>
            <li><a href="#/newsCenter/honor">下一篇：荣誉丨功存智能获得CMMI三级证书</a></li>
          </ul>
        </div>
      </div>    
    </el-main>
    <el-footer>
      <footerMenu/>
    </el-footer>
  </el-container>
</template>

<script>
import navmenu from '../../components/navmenu.vue';
import footerMenu from '../../components/footer.vue';

export default {
  components: { navmenu,footerMenu },

  data(){
    return{
      imgList:[
        {
          name: "banner1",
          title:'新闻中心',
          detail:'News center',
          src: require("../../../public/newsImg/newsbanner.png"),
        },
      ]
    }
  },
  mounted(){
    console.log(this.$route)
  }
}
</script>
<style lang="scss" scoped>
@import '~@/assets/style/public.scss';

.block{
  position: relative;
  .pic_item {
    position: relative;
    height: 100%;
    h3{
      position: absolute;
      width: 1200px;
      left: 50%;
      transform: translateX(-50%);
      text-align: left;
      top: 132px;        
      font-size: 60px;
      font-family: PingFang SC;
      font-weight: 800;
      line-height: 100px;
      color: #FFFFFF;
      opacity: 1;
      animation:moveh3 3s infinite;
      // animation-iteration-count:1;
      @keyframes moveh3{
        from {left:60%;opacity: 0;}
        to {left:50%;opacity: 1;}
      }
      @-webkit-keyframes moveh3 /*Safari and Chrome*/{
        from {left:60%;opacity: 0;}
        to {left:50%;opacity: 1;}
      }
    }      
    p{
      position: absolute;
      width: 1200px;
      left: 50%;
      transform: translateX(-50%);
      text-align: left;
      top: 242px;        
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 100px;
      color: #FFFFFF;
      opacity: 1;
      animation:movep 3s infinite;
      @keyframes movep{
        from {top: 282px;opacity: 0;}
        to {top: 242px;opacity: 1;}
      }
      @-webkit-keyframes movep /*Safari and Chrome*/{
        from {top: 282px;opacity: 0;}
        to {top: 242px;opacity: 1;}
    }
    }      
  }
  .pic_item:hover{
    cursor: pointer;
  }
}

  .view-tip{
    width: 1200px;   
    margin: 0 auto;
    margin-bottom: 90px;
    text-align: left;
    .title{
      height: 33px;
      text-align: left;
      font-size: 24px;
      font-weight: bold;
      margin: 0 0 10px;
      padding-left: 10px;
      border-left: solid 3px #1E8DD4;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: pre !important;
    }
    .detail{
      margin-top: 32px;
      text-align: left;
      font-size: 16px;
      line-height: 32px;
      color: #666;
      padding-left: 13px;
      p{
        margin-top:-3px
      }
      span{
        font-size: 18px;
        font-weight: bold;
        line-height: 20px;
        margin-bottom: 10px;
      }
      ul{
        list-style-type: none;
        margin-left: 5px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        li{
          padding-bottom: 20px;
          // width: 326px;
        }
      }
    }
  }


.solution{
  height:1708px;
  .breadCrumb{
    height: 67px;
    border-bottom: 1px solid #ccc;
  }
  .content{
    height: 1450px;
    p{
      font-size: 16px;
      line-height: 32px;
    }
    .title{
      height: 33px;
      padding-top: 60px;
      p{
        font-size: 26px;
        font-weight: bold;
      }
      
    }
    .detail{
      text-align: left;
      padding-top: 64px;
      .picImg_Content{
        display: flex;
        justify-content: space-around;
        width: 1200px;
        .picImg{
          img{
            width: 600px;
          }
          
          // height: 426px;
          // margin: 0 auto;
        }
      }
      
    }
  }
  .footNav{
    ul{
      height: 128px;
      line-height: 128px;
      font-size: 16px;
      color: #fff;
      display: flex;
      justify-content: space-around;
    }
    li:hover{
      cursor: pointer;
      height: 148px;
    }
    li{
      a{
        color: #fff;
      }
      width: 50%;
      height: 100%;      
    }
    li:first-child{
      background: url("../../../public/newsImg/libg_1.png");
    }
    li:last-child{
      background: url("../../../public/newsImg/libg_2.png ");
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/newsCenter/activity.vue